export default __webpack_public_path__ + "static/media/CNo.38-6.e1e6d0ec.jpg";